import FieldControl from 'global/form/FieldControl';
import * as adapters from 'global/form/validationAdapters';

// TODO Rename class to CreatePasswordFieldControl and file to CreatePasswordFieldControl.js
class ResetPasswordFieldControl extends FieldControl {
	constructor(fieldNode, rules) {
		super(fieldNode, rules);

		this.createPasswordFieldClass = 'create-password-field-control';

		// We don't validate maxlength in this scenario
		if (Object.prototype.hasOwnProperty.call(this.rules, 'maxlength')) {
			delete this.rules.maxlength;
		}
	}

	attachFieldEvents() {
		const eventType =
			this.field.getAttribute('data-validation-event') || 'keyup';
		this.field.addEventListener(eventType, () => this.validateField(false));
		this.field.addEventListener('blur', () => this.validateFieldOnBlur());
	}

	validateField(showErrors = true) {
		this.validMessages = [];
		this.showErrors = showErrors;
		return super.validateField();
	}

	validateFieldOnBlur() {
		if (
			Object.prototype.hasOwnProperty.call(this.rules, 'required') &&
			this.rules.required.rule &&
			this.field.value === ''
		) {
			this.field.classList.add('is-invalid');

			// TODO This feels brittle as it is based around the DOM structure
			this.formText.parentElement.classList.add(
				`${this.createPasswordFieldClass}--is-invalid`,
			);
		}
	}

	validateRule(key) {
		if (key === 'pattern-list') {
			const validListRules = this.rules[key].filter(ruleSet =>
				this.validateRuleList(ruleSet),
			);
			return validListRules.length === this.rules[key].length;
		}

		const isValid = super.validateRule(key);

		const { message } = this.rules[key];

		return this.setValidMessages(isValid, message);
	}

	validateRuleList(ruleSet) {
		const { value } = this.field;
		const { rule, message } = ruleSet;
		const isValid = adapters.patternList(value, rule);
		return this.setValidMessages(isValid, message);
	}

	setValidMessages(isValid, message) {
		if (isValid) {
			this.validMessages.push(message);
		}

		return isValid;
	}

	updateFieldState() {
		if (this.showErrors || this.isValid) {
			this.updateFieldErrorClass();
		}
		this.updateFieldErrorMessage();
		this.publishRulesState();
	}

	publishRulesState() {
		window.od.events.publish('password-rules-state', this.allRulesPassed());
	}

	allRulesPassed() {
		const { validMessages } = this;
		const listItems = [...this.formText.querySelectorAll('li')];
		const rulesPassed = listItems.map(item =>
			validMessages.includes(item.innerText),
		);

		return rulesPassed.every(bool => bool);
	}

	updateFieldErrorMessage() {
		const defaultClass = `${this.createPasswordFieldClass}__criteria-item`;
		const successClass = `${this.createPasswordFieldClass}__criteria-item--success`;

		const listItems = this.formText.querySelectorAll('li');

		for (let i = 0; i < listItems.length; i += 1) {
			const text = listItems[i].innerHTML;
			const isValid = this.validMessages.indexOf(text) > -1;
			listItems[i].className = isValid
				? `${defaultClass} ${successClass}`
				: defaultClass;
		}
	}

	updateFieldErrorClass() {
		super.updateFieldErrorClass();

		if (this.isValid || this.isOptional()) {
			this.formText.parentElement.classList.remove(
				`${this.createPasswordFieldClass}--is-invalid`,
			);
		}
	}
}

export default ResetPasswordFieldControl;
